export default "__VITE_ASSET__DJNDB$Ga__"